<mat-form-field
  [class.invalid-field]="!form.valid && submitted"
  appearance="outline"
  >
  <input
    type="text"
    matInput
    (focusout)="onFocusOut()"
    (keydown)="onKeyDown()"
    (keyup)="onKeyUp($event.target.value)"
    [matAutocomplete]="auto"
    [value]="getValue()"
    />

  <mat-autocomplete
    #auto="matAutocomplete"
    [class]="showGoogleIcon === true ? 'powered-by-google' : ''"
    >
    @if (showOnFocus || isFocused) {
      @if (isToSearchBetweenOptions) {
        @for (option of filteredOptions | async; track option) {
          <mat-option
            (click)="choseItem(option)"
            [value]="option.display"
            >
            {{ option.display }}
          </mat-option>
        }
      }
      @if (!isToSearchBetweenOptions) {
        @for (option of options; track option) {
          <mat-option
            (click)="choseItem(option)"
            [value]="option.display"
            >
            {{ option.display }}
          </mat-option>
        }
      }
    }
  </mat-autocomplete>
  @if (label) {
    <mat-label>
      @if (icon) {
        <tidy-image [src]="icon" class="black outline-field-label-icon" />
      }
      <tidy-text [body]="label" />
    </mat-label>
  }
</mat-form-field>
@if (!form.valid && submitted) {
  <tidy-error-message [text]="errorMessage" />
}
